import React, { useLayoutEffect, useRef, useEffect, useState } from "react";

import AddAppointment from "./AddAppointment";
import DefineSlotOrder from "./DefineSlotOrder";

import Calendar from "./Calendar";
import {
  fetchApartmentsListingsData,
  DeletedListingsAndInfo,
  updateAutomaticEmail,
  ListApartment,
} from "./DataServices/ApartmentsListingsDataServices";
import {
  saveAppointments,
  fetchAppointmentsPerListingData,
} from "./DataServices/AppointmentsDataServices";
import AddListing from "./AddListing";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import {
  EllipsisVerticalIcon,
  MagnifyingGlassIcon,
  Cog6ToothIcon,
} from "@heroicons/react/20/solid";
import { useNavigate } from "react-router-dom";
import MessageBox from "./MessageBox";
import Notification from "./Notification";
import PencilIcon from "@heroicons/react/24/outline/PencilIcon";
import EmailIcon from "@mui/icons-material/Email";
import BedIcon from "@mui/icons-material/Bed";
import ApartmentIcon from "@mui/icons-material/Apartment";
import RoomIcon from "@mui/icons-material/Room";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import {
  CalendarDaysIcon,
  CheckBadgeIcon,
  CheckCircleIcon,
  MinusCircleIcon,
  PlusIcon,
  TrashIcon,
  EyeIcon,
  EyeSlashIcon,
  ChartBarIcon,
  BookmarkIcon,
  UserGroupIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";
import Loading from "./Loading";
import { PauseCircle, PlayCircle } from "@mui/icons-material";
import { IAvailableAppointment, Reminder } from "./Models";
import TenantImporter from "./TenantImporter";
import { getDraftCount } from "./DataServices/EmailDraftService";

export interface IListing {
  id: string;
  idApartment: string;
  title: string;
  zillowTitle: string;
  description: string;
  rent: string;
  moveInDate: string;
  showings: string;
  areAvailableAppointmentsSet: boolean;
  isSelected: boolean;
  isVacant: boolean;
  building: string;
  line: string;
  floor: number;
  numOfBedrooms: number;
  currentRent: number;
  automaticEmail: boolean;
  accessCode: string;
  appfolioLink: string;
  youTubeLink: string;
  workflowType?: number;
  futureAvailableAppointmentsCount?: number;
}

export default function Home() {
  function classNames(...classes: any[]) {
    return classes.filter(Boolean).join(" ");
  }

  const [
    showCalendarConfirmedAppointments,
    setShowCalendarConfirmedAppointments,
  ] = useState(true);
  const [showAddListing, setShowAddListing] = useState(false);
  const [showDefineSlotOrder, setShowDefineSlotOrder] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [emailCounts, setEmailCounts] = useState<Record<string, number>>({});
  const emailCountFetchedRef = useRef<Set<string>>(new Set());

  const [availableAppointments, setAvailableAppointments] = useState<
    IAvailableAppointment[]
  >([]);
  const [emptyAppointments, setEmptyAppointments] = useState<
    IAvailableAppointment[]
  >([]);
  const [availableAppointmentsPerListing, setAvailableAppointmentsPerListing] =
    useState<IAvailableAppointment[]>([]);
  const [confirmedAppointments, setConfirmedAppointments] = useState<
    IAvailableAppointment[]
  >([]);

  //for test
  useEffect(() => {
    // This code will run whenever availableAppointments state changes
  }, [availableAppointmentsPerListing]);

  const emptyAppointment: IAvailableAppointment = {
    id: "",
    listingID: "",
    startTime: null,
    endTime: null,
    capacity: 0,
    slotOrder: 0,
    groupId: "",
    reminders: [],
  };

  const handleAutomaticEmail = async (apartmentForAppointment: IListing) => {
    try {
      await updateAutomaticEmail(apartmentForAppointment.idApartment);
      setRefreshApartments(true);
    } catch (error) {
      console.log("Error in handleAutomaticEmail:", error);
    }
  };

  useEffect(() => {}, [availableAppointments]);
  const navigate = useNavigate();
  const checkbox = useRef<HTMLInputElement>(null);
  const [checked, setChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const [selectedListings, setSelectedListings] = useState<IListing[]>([]);
  const [selectedListingsToBeDeleted, setSelectedListingsToBeDeleted] =
    useState<IListing[]>([]);
  const [
    selectedListingsToAddAppointment,
    setSelectedListingsToAddAppointment,
  ] = useState<IListing>();
  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [openMessageBox2, setOpenMessageBox2] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [openAddAppointment, setOpenAddAppointment] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listings, setListings] = useState<IListing[]>([]);
  const [emptyListings, setEmptyListings] = useState<IListing[]>([]);
  const [refreshApartments, setRefreshApartments] = useState<boolean>(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [notificationMessageType, setNotificationMessageType] =
    useState("success");
  const [openAppointments, setOpenAppointments] = useState<
    IAvailableAppointment[]
  >([]);
  const [listed, setListed] = useState(true);
  const [mobileOptionsOpen, setMobileOptionsOpen] = useState(false);
  const [selectedApartmentForOptions, setSelectedApartmentForOptions] =
    useState<IListing | null>(null);

  const handleOpenMobileOptions = (apartment: IListing) => {
    setSelectedApartmentForOptions(apartment);
    setMobileOptionsOpen(true);
  };

  const handleCloseMobileOptions = () => {
    setMobileOptionsOpen(false);
    setSelectedApartmentForOptions(null);
  };

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        const data = await fetchApartmentsListingsData(listed);
        setListings(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data:", error);
        // You can handle the error state here if needed
      }
    }
    fetchData();
  }, [listed, openAddAppointment]); // The empty dependency array ensures that this effect runs only once, like componentDidMount

  useLayoutEffect(() => {
    const isIndeterminate =
      selectedListings.length > 0 && selectedListings.length < listings.length;
    setChecked(
      selectedListings.length === listings.length &&
        selectedListings.length > 0,
    );
    setIndeterminate(isIndeterminate);
    if (checkbox.current !== null) {
      checkbox.current.indeterminate = isIndeterminate;
    }
  }, [selectedListings]);

  const handleApartmentSelection = (apartment: IListing) => {
    if (selectedListings.includes(apartment)) {
      setSelectedListings(selectedListings.filter((a) => a !== apartment));
    } else {
      setSelectedListings([...selectedListings, apartment]);
    }
  };

  const handleAddApartment = () => {
    setSelectedListings([]);
    setShowAddListing(true);
  };

  const handleDeleteApartment = async (apartment: IListing) => {
    setSelectedListingsToBeDeleted([]);
    setSelectedListingsToBeDeleted([apartment]);
    const appointments = await fetchAppointmentsPerListingData(apartment.id);
    setOpenAppointments(appointments);
    setOpenMessageBox(true);
  };

  const handleListApartment = async (id: string) => {
    try {
      await ListApartment(id);
      setOpenNotification(true);
      setNotificationMessage(
        "Apartment " + (listed ? "UnList" : "List") + " successfully!",
      );
      setNotificationMessageType("success");
      setTimeout(() => {
        setOpenNotification(false);
      }, 3000);

      setRefreshApartments(true);
    } catch (error) {
      console.error("Error deleting apartments:", error);
      setNotificationMessage("Failed to delete Apartment!");
      setNotificationMessageType("error");
      setTimeout(() => {
        setOpenNotification(false);
      }, 3000);
    } finally {
      setOpenMessageBox(false);
    }
  };

  const handleDeleteApartments = () => {
    setSelectedListingsToBeDeleted([]);
    setSelectedListingsToBeDeleted(selectedListings);
    setOpenMessageBox(true);
  };

  const handleAddEditListing = (apt: IListing) => {
    const updatedListings = listings.map((listing) => ({
      ...listing,
      isSelected: false,
    }));
    setListings(updatedListings);

    setSelectedListings([]);
    setSelectedListings([apt]);
    setShowAddListing(true);
  };

  //delete listing(s) after
  const okButtonFunction = async () => {
    try {
      if (openAppointments.length > 0) {
        setOpenMessageBox2(true);
      } else {
        const appointments = await DeletedListingsAndInfo(
          selectedListingsToBeDeleted,
        );

        setAvailableAppointmentsPerListing(appointments);
        setOpenNotification(true);
        setNotificationMessage(
          "Apartment " + (listed ? "UnList" : "List") + " successfully!",
        );
        setNotificationMessageType("success");
        setTimeout(() => {
          setOpenNotification(false);
        }, 3000);

        setRefreshApartments(true);
        setSelectedListingsToBeDeleted([]);
        setSelectedListings([]);
      }
    } catch (error) {
      console.error("Error deleting apartments:", error);
      setNotificationMessage("Failed to delete Apartment!");
      setNotificationMessageType("error");
      setTimeout(() => {
        setOpenNotification(false);
      }, 3000);
    } finally {
      setOpenMessageBox(false);
    }
  };
  const okButtonFunction2 = async () => {
    DeletedListingsAndInfo(selectedListingsToBeDeleted)
      .then((appointments) => {
        setOpenNotification(true);
        setAvailableAppointmentsPerListing(appointments);
        setNotificationMessage("Apartment deleted successfully!");
        setNotificationMessageType("success");
        setOpenNotification(true);
        setTimeout(() => {
          setOpenNotification(false);
        }, 3000);
        setRefreshApartments(true);
      })
      .catch((error: any) => {
        console.error("Error deleting apartment:", error);
        setNotificationMessage("Failed to delete Apartment!");
        setNotificationMessageType("error");
        setOpenNotification(true);
        setTimeout(() => {
          setOpenNotification(false);
        }, 3000);
      });
    setOpenMessageBox(false);
    setOpenMessageBox2(false);
    setSelectedListingsToBeDeleted([]);
    setSelectedListings([]);
  };

  //delete listing(s) after
  const cancelButtonFunction = () => {
    setOpenMessageBox(false);
  };

  const handleAddEditAutomaticEmailResponse = () => {
    setShowAddListing(true);
  };

  const handleShowDefineSlotOrder = () => {
    setShowDefineSlotOrder(true);
  };

  const handleShowAvailableAppointments = (
    apartmentForAppointment: IListing,
  ) => {
    fetchAppointmentsPerListingData(apartmentForAppointment.id)
      .then((appointments) => {
        const now = new Date();
        const newAppointments = appointments.filter(
          (appointment: any) =>
            appointment.endTime && new Date(appointment.endTime) > now,
        );

        setAvailableAppointmentsPerListing(newAppointments);
      })
      .catch((error: any) => {
        console.error("Error fetching appointments:", error);
      });

    setShowCalendarConfirmedAppointments(false);
    setEmptyListings([apartmentForAppointment]);
    setShowCalendar(true);
  };

  const handleAddAppointment = (listingForAppointment: IListing) => {
    setSelectedListingsToAddAppointment(listingForAppointment);
    setOpenAddAppointment(true);
  };

  useEffect(() => {
    if (refreshApartments) {
      const fetchData = async () => {
        try {
          setListings([]);
          const data = await fetchApartmentsListingsData(listed);
          setListings(data);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setRefreshApartments(false);
        }
      };
      fetchData();
    }
  }, [refreshApartments, setRefreshApartments, setListings, listed]);

  function toggleAll() {
    setSelectedListings(checked || indeterminate ? [] : listings);
    setChecked(!checked && !indeterminate);
    setIndeterminate(false);
  }

  const handleModalClose = (): void => {
    setRefreshApartments(true);
  };

  const handleSearch = (query: string) => setSearchQuery(query);
  const filteredListings = listings.filter((apartment) =>
    apartment.title.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const handleShowApartmentListing = () => {
    setListed(!listed);
  };
  const loadedRef = useRef(false);

  useEffect(() => {
    if (listings.length === 0 || loadedRef.current) return;

    loadedRef.current = true;

    async function loadEmailCounts() {
      const counts: Record<string, number> = {};
      for (const apt of listings) {
        counts[apt.id] = await getDraftCount(apt.id);
      }
      setEmailCounts(counts);
    }

    loadEmailCounts();
  }, [listings]);

  return (
    <>
      <div className="mt-20">
        {showCalendar ? (
          <Calendar
            setShowCalendar={setShowCalendar}
            relatedListing={emptyListings}
            showAvailableAppointments={!showCalendarConfirmedAppointments}
          />
        ) : (
          <div className="px-2 sm:px-4 lg:px-8 relative">
            {/* Responsive Header */}
            <div className="flex flex-col gap-3 pb-4">
              {/* Row 1: Heading and Notification */}
              <div className="flex items-center justify-between gap-2">
                <h1 className="text-xl sm:text-2xl font-bold text-gray-900 tracking-tight truncate">
                  {listed ? "Listed Apartments" : "Unlisted Apartments"}
                </h1>
                <div className="sm:hidden">
                  <Notification
                    isOpen={openNotification}
                    message={notificationMessage}
                    messageType={notificationMessageType}
                    setIsOpen={setOpenNotification}
                  />
                </div>
              </div>

              {/* Row 2: Search Bar */}
              <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                <div className="relative flex-1 sm:max-w-md">
                  <MagnifyingGlassIcon
                    className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 sm:h-5 sm:w-5 text-gray-400"
                    aria-hidden="true"
                  />
                  <input
                    type="text"
                    name="search"
                    id="search"
                    placeholder="Search By Title..."
                    onChange={(e) => handleSearch(e.target.value)}
                    className="pl-9 sm:pl-10 pr-3 sm:pr-4 py-2.5 sm:py-2 w-full rounded-xl border border-gray-200 text-sm text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition shadow-sm"
                  />
                </div>
                <div className="hidden sm:block">
                  <Notification
                    isOpen={openNotification}
                    message={notificationMessage}
                    messageType={notificationMessageType}
                    setIsOpen={setOpenNotification}
                  />
                </div>
              </div>

              {/* Row 3: Action Buttons */}
              <div className="flex flex-wrap justify-start sm:justify-end gap-2 w-full">
                <button
                  type="button"
                  onClick={handleShowApartmentListing}
                  className="inline-flex items-center justify-center gap-1 sm:gap-2 py-2 px-3 sm:px-4 text-xs sm:text-sm font-medium rounded-lg bg-blue-50 text-blue-700 hover:bg-blue-100 active:scale-[0.98] transition-all duration-200 w-[calc(50%-0.25rem)] sm:w-auto flex-none"
                >
                  {listed ? (
                    <EyeSlashIcon className="h-4 w-4 hidden sm:block" />
                  ) : (
                    <EyeIcon className="h-4 w-4 hidden sm:block" />
                  )}
                  <span>Show {listed ? "Unlisted" : "Listed"}</span>
                </button>
                <button
                  type="button"
                  onClick={() => navigate("/extracted-apartments")}
                  className="inline-flex items-center justify-center gap-1 sm:gap-2 py-2 px-3 sm:px-4 text-xs sm:text-sm font-medium rounded-lg bg-blue-50 text-blue-700 hover:bg-blue-100 active:scale-[0.98] transition-all duration-200 w-[calc(50%-0.25rem)] sm:w-auto flex-none"
                >
                  <UserGroupIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
                  <span className="">Extracted Data</span>
                </button>
                <button
                  type="button"
                  onClick={handleAddApartment}
                  className="inline-flex items-center justify-center gap-1 sm:gap-2 py-2 px-3 sm:px-4 text-xs sm:text-sm font-medium rounded-lg bg-blue-50 text-blue-700 hover:bg-blue-100 active:scale-[0.98] transition-all duration-200 w-[calc(50%-0.25rem)] sm:w-auto flex-none"
                >
                  <PlusIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
                  <span className="">Add Apartment</span>
                </button>
                <button
                  type="button"
                  onClick={() => (window.location.href = "/assistant-settings")}
                  className="inline-flex items-center justify-center gap-1 sm:gap-2 py-2 px-3 sm:px-4 text-xs sm:text-sm font-medium rounded-lg bg-blue-50 text-blue-700 hover:bg-blue-100 active:scale-[0.98] transition-all duration-200 w-[calc(50%-0.25rem)] sm:w-auto flex-none"
                >
                  <Cog6ToothIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
                  <span className="">AI Assistant</span>
                </button>
                <button
                  type="button"
                  onClick={() => (window.location.href = "/notes")}
                  className="inline-flex items-center justify-center gap-1 sm:gap-2 py-2 px-3 sm:px-4 text-xs sm:text-sm font-medium rounded-lg bg-blue-50 text-blue-700 hover:bg-blue-100 active:scale-[0.98] transition-all duration-200 w-[calc(50%-0.25rem)] sm:w-auto flex-none"
                >
                  <BookmarkIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
                  <span className="">Notes</span>
                </button>
                <TenantImporter />
              </div>
            </div>

            <div className="mt-4 sm:mt-5 flow-root">
              <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                  <div className="">
                    {selectedListings.length > 0 && (
                      <div className="relative">
                        <div className="absolute left-14 top-0 flex h-12 items-center space-x-3 bg-gray-100 sm:left-12">
                          <button
                            type="button"
                            onClick={handleDeleteApartments}
                            className="inline-flex items-center rounded bg-gray-100 px-2 py-1 text-sm font-semibold text-black shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-whitr"
                          >
                            {listed ? "UnList Selected" : "List Selected"}
                          </button>
                        </div>
                      </div>
                    )}
                    {/* Mobile Card View */}
                    <div className="block sm:hidden space-y-3">
                      {filteredListings.length > 0 &&
                        filteredListings.map((apartment, i) => (
                          <div
                            key={i}
                            className={`border rounded-lg p-4 shadow-sm bg-white ${selectedListings.includes(apartment) ? "ring-2 ring-indigo-500" : ""}`}
                          >
                            <div className="flex items-start justify-between">
                              <div className="flex items-start gap-3">
                                <input
                                  type="checkbox"
                                  className="mt-1 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                                  checked={selectedListings.includes(apartment)}
                                  onChange={() =>
                                    handleApartmentSelection(apartment)
                                  }
                                />
                                <div className="flex-1">
                                  <h3 className="font-medium text-gray-900">
                                    {apartment.title}
                                  </h3>
                                  <div className="flex items-center gap-2 mt-1">
                                    <BedIcon
                                      style={{ fontSize: "14px" }}
                                      className="text-gray-400"
                                    />
                                    <span className="text-xs text-gray-500">
                                      {apartment.numOfBedrooms} bedroom
                                      {apartment.numOfBedrooms !== 1 ? "s" : ""}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <button
                                onClick={() =>
                                  handleOpenMobileOptions(apartment)
                                }
                                className="p-2 text-gray-500 hover:text-gray-900 relative"
                              >
                                <EllipsisVerticalIcon className="h-5 w-5" />
                                {emailCounts[apartment.id] > 0 && (
                                  <span className="absolute h-2 w-2 bg-red-600 rounded-full top-1 right-1"></span>
                                )}
                              </button>
                            </div>

                            <div className="mt-3 space-y-2">
                              <div className="flex items-center gap-2">
                                <ApartmentIcon
                                  style={{ fontSize: "14px" }}
                                  className="text-gray-400"
                                />
                                <span className="text-sm text-gray-700">
                                  {apartment.building}
                                </span>
                              </div>
                              <div className="flex items-center gap-2">
                                <RoomIcon
                                  style={{ fontSize: "14px" }}
                                  className="text-gray-400"
                                />
                                <span className="text-xs text-gray-500">
                                  Line {apartment.line}, Floor {apartment.floor}
                                </span>
                              </div>
                            </div>

                            <div className="mt-3 flex items-center justify-between">
                              <div>
                                <div className="flex items-center gap-1">
                                  <span className="text-sm font-semibold text-gray-900">
                                    $ {apartment.rent ?? 0}
                                  </span>
                                  <span className="text-xs text-gray-500">
                                    Rental
                                  </span>
                                </div>
                                <div className="flex items-center gap-1">
                                  <span className="text-sm text-gray-600">
                                    $ {apartment.currentRent ?? 0}
                                  </span>
                                  <span className="text-xs text-gray-500">
                                    Current
                                  </span>
                                </div>
                              </div>
                              <div className="text-right">
                                <div className="text-xs text-gray-500">
                                  Move-In
                                </div>
                                <div className="text-sm text-gray-700">
                                  {apartment.moveInDate
                                    ? new Date(
                                        apartment.moveInDate,
                                      ).toLocaleDateString()
                                    : "-"}
                                </div>
                              </div>
                              <div className="flex items-center gap-1">
                                <span
                                  className={`w-2.5 h-2.5 rounded-full ${(apartment.futureAvailableAppointmentsCount ?? 0) > 0 ? "bg-green-500" : "bg-gray-400"}`}
                                ></span>
                                <span className="text-sm text-gray-600">
                                  {apartment.futureAvailableAppointmentsCount}{" "}
                                  slots
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      {loading && (
                        <div className="flex items-center justify-center p-8">
                          <Loading />
                        </div>
                      )}
                      {filteredListings.length === 0 && !loading && (
                        <div className="text-gray-400 text-sm w-full border rounded-md shadow flex items-center justify-center p-4">
                          No Apartments
                        </div>
                      )}
                    </div>

                    {/* Desktop Table View */}
                    <div className="hidden sm:block border rounded-md overflow-hidden shadow">
                      <table className="min-w-full table-fixed divide-y divide-gray-300">
                        <thead className="text-center border-0  rounded-t-md overflow-hidden">
                          <tr>
                            <th
                              scope="col"
                              className="relative px-7 sm:w-12 sm:px-6"
                            >
                              <input
                                type="checkbox"
                                className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                                ref={checkbox}
                                checked={checked}
                                onChange={toggleAll}
                              />
                            </th>

                            <th
                              scope="col"
                              className="py-3.5 px-3 text-left text-sm font-semibold text-black"
                            >
                              Title
                            </th>

                            <th
                              scope="col"
                              className="py-3.5 pr-3 text-left text-sm font-semibold  text-black"
                            >
                              Building
                            </th>

                            {/* <th
                              scope="col"
                              className="py-3.5 pr-3 text-left text-sm font-semibold text-white"
                            >
                              Line
                            </th> */}

                            {/* <th
                              scope="col"
                              className="py-3.5 pr-3 text-left text-sm font-semibold  text-white"
                            >
                              Floor
                            </th> */}

                            <th
                              scope="col"
                              className="pr-3 py-3.5 text-left text-sm font-semibold  text-black"
                            >
                              Pricing
                            </th>

                            {/* <th
                              scope="col"
                              className="pr-3 py-3.5 text-left text-sm font-semibold  text-white"
                            >
                              Current Rent
                            </th> */}
                            <th
                              scope="col"
                              className="pr-3 py-3.5 text-left text-sm font-semibold  text-black"
                            >
                              Move-In Date
                            </th>

                            {/* <th
                              scope="col"
                              className="pr-3 py-3.5 text-left text-sm font-semibold  text-white"
                            >
                              Num Of Bedrooms
                            </th> */}
                            <th
                              scope="col"
                              className="pr-3 py-3.5 text-left text-sm font-semibold  text-black"
                            >
                              Next Slots
                            </th>
                            <th
                              scope="col"
                              className="relative py-3.5 pl-3 pr-4 sm:pr-3"
                            >
                              <span className="sr-only">Edit</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody
                          className={
                            "divide-y divide-gray-200 bg-white " +
                            (loading && "relative")
                          }
                        >
                          {filteredListings.length > 0 &&
                            filteredListings.map((apartment, i) => (
                              <tr
                                key={i}
                                className={`py-4 border-b ${
                                  selectedListings.includes(apartment)
                                    ? "bg-gray-50"
                                    : ""
                                }`}
                              >
                                <td className="relative px-7 sm:w-12 sm:px-6">
                                  {selectedListings.includes(apartment) && (
                                    <div className="absolute inset-y-0 left-0 w-0.5 bg-indigo-600" />
                                  )}
                                  <input
                                    type="checkbox"
                                    className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                                    value={
                                      apartment.moveInDate
                                        ? apartment.moveInDate
                                        : ""
                                    }
                                    checked={selectedListings.includes(
                                      apartment,
                                    )}
                                    onChange={() =>
                                      handleApartmentSelection(apartment)
                                    }
                                  />
                                </td>

                                {/* <td
                                  className={classNames(
                                    "whitespace-nowrap p-3 text-sm font-medium",
                                    selectedListings.includes(apartment)
                                      ? "text-indigo-600"
                                      : "text-gray-900"
                                  )}
                                >
                                  {apartment.title}
                                </td> */}
                                <td className="px-3 py-4">
                                  <div className="flex flex-col">
                                    <div className="flex items-center gap-2">
                                      <span
                                        className={`font-medium ${
                                          selectedListings.includes(apartment)
                                            ? "text-blue-900"
                                            : "text-gray-900"
                                        }`}
                                      >
                                        {apartment.title}
                                      </span>
                                      {apartment.workflowType === 0 && (
                                        <span className="inline-flex items-center rounded-full bg-purple-100 px-2 py-1 text-xs font-semibold leading-none text-purple-700 ring-1 ring-inset ring-purple-600/20">
                                          Mandatory Flow
                                        </span>
                                      )}
                                    </div>
                                    <div className="flex items-center gap-2 mt-1">
                                      <BedIcon
                                        style={{ fontSize: "15px" }}
                                        className="text-gray-400"
                                      />

                                      <span className="text-xs text-gray-500">
                                        {apartment.numOfBedrooms} bedroom
                                        {apartment.numOfBedrooms !== 1
                                          ? "s"
                                          : ""}
                                      </span>
                                    </div>
                                  </div>
                                </td>

                                {/* <td className="whitespace-nowrap p-3 text-sm text-gray-500">
                                  {apartment.building}
                                </td>

                                <td className="whitespace-nowrap p-3 text-sm text-gray-500">
                                  {apartment.line}
                                </td> */}

                                <td className="px-0 py-4">
                                  <div className="flex flex-col gap-1">
                                    <div className="flex items-center gap-2">
                                      <ApartmentIcon
                                        style={{ fontSize: "15px" }}
                                        className="text-gray-400"
                                      />
                                      <span className="text-sm text-gray-900">
                                        {apartment.building}
                                      </span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                      <RoomIcon
                                        style={{ fontSize: "15px" }}
                                        className="text-gray-400"
                                      />
                                      <span className="text-xs text-gray-500">
                                        Line {apartment.line}, Floor{" "}
                                        {apartment.floor}
                                      </span>
                                    </div>
                                  </div>
                                </td>

                                {/* <td className="whitespace-nowrap p-3 text-sm text-gray-500">
                                  {apartment.floor}
                                </td> */}

                                <td className="px-0 py-4">
                                  <div className="flex flex-col gap-1">
                                    <div className="flex items-center ">
                                      <span className="text-sm font-medium text-gray-900 mr-2">
                                        $ {apartment.rent ?? 0}
                                      </span>
                                      <span className="text-xs text-gray-500">
                                        Rental
                                      </span>
                                    </div>
                                    <div className="flex items-center ">
                                      <span className="text-sm text-gray-600 mr-2">
                                        $ {apartment.currentRent ?? 0}
                                      </span>
                                      <span className="text-xs text-gray-500">
                                        Current
                                      </span>
                                    </div>
                                  </div>
                                </td>

                                <td className="whitespace-nowrap p-3 text-sm text-gray-500">
                                  {apartment.moveInDate
                                    ? new Date(
                                        apartment.moveInDate,
                                      ).toLocaleDateString()
                                    : ""}
                                </td>

                                {/* 
                                <td className="whitespace-nowrap p-3.5 text-sm text-gray-500">
                                  {apartment.numOfBedrooms}
                                </td> */}

                                <td className="whitespace-nowrap py-8 px-6 text-sm text-gray-500 flex items-center">
                                  <span
                                    className={`w-3 h-3 rounded-full mr-2 ${
                                      (apartment.futureAvailableAppointmentsCount ??
                                        0) > 0
                                        ? "bg-green-500"
                                        : "bg-gray-400"
                                    }`}
                                  ></span>

                                  {apartment.futureAvailableAppointmentsCount}
                                </td>

                                <td>
                                  <Menu as="div" className="flex-none">
                                    <Menu.Button className="-m-2.5 p-2.5 text-gray-500 hover:text-gray-900 flex items-center justify-center relative">
                                      <span className="sr-only">
                                        Open options
                                      </span>
                                      <EllipsisVerticalIcon
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                      />
                                      {emailCounts[apartment.id] > 0 && (
                                        <span
                                          className="absolute h-2 w-2 bg-red-600 rounded-full"
                                          style={{ top: "2px", right: "2px" }}
                                        ></span>
                                      )}
                                    </Menu.Button>
                                    <Transition
                                      as={Fragment}
                                      enter="transition ease-out duration-100"
                                      enterFrom="transform opacity-0 scale-95"
                                      enterTo="transform opacity-100 scale-100"
                                      leave="transition ease-in duration-75"
                                      leaveFrom="transform opacity-100 scale-100"
                                      leaveTo="transform opacity-0 scale-95"
                                    >
                                      <Menu.Items className="absolute right-2 z-10 mt-2 origin-bottom-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                                        <Menu.Item>
                                          {({ active }) => (
                                            <a
                                              onClick={() =>
                                                handleAddEditListing(apartment)
                                              }
                                              href="#"
                                              className={classNames(
                                                active ? "bg-gray-50" : "",
                                                "flex px-3 py-2 items-center text-sm leading-6 text-gray-900",
                                              )}
                                            >
                                              <PencilIcon className="h-5 w-5 mt-1 mr-1" />
                                              Edit Appartment
                                              <span className="sr-only"></span>
                                            </a>
                                          )}
                                        </Menu.Item>
                                        <Menu.Item>
                                          {({ active }) => (
                                            <a
                                              onClick={() =>
                                                navigate(
                                                  `/timeline/by-listing/${apartment.id}`,
                                                )
                                              }
                                              href="#"
                                              className={classNames(
                                                active ? "bg-gray-50" : "",
                                                "flex px-3 py-2 items-center text-sm leading-6 text-gray-900",
                                              )}
                                            >
                                              <ClockIcon className="h-5 w-5 mt-1 mr-1" />
                                              View Timeline
                                              <span className="sr-only"></span>
                                            </a>
                                          )}
                                        </Menu.Item>
                                        {/*
                                      <Menu.Item>
                                        {({ active }) => (
                                          <a
                                            onClick={(event) =>
                                              handleDeleteApartment(apartment)
                                            }
                                            href="#"
                                            className={classNames(
                                              active ? "bg-gray-50" : "",
                                              "flex px-3 py-2 items-center text-sm leading-6 text-gray-900"
                                            )}
                                          >
                                            <TrashIcon className="h-5 w-5 mt-1 mr-1" />{" "}
                                            Delete Apartment
                                            <span className="sr-only"> </span>
                                          </a>
                                        )}
                                      </Menu.Item> */}

                                        <Menu.Item>
                                          {({ active }) => (
                                            <>
                                              <a
                                                onClick={(event) =>
                                                  handleDeleteApartment(
                                                    apartment,
                                                  )
                                                }
                                                href="#"
                                                className={classNames(
                                                  active ? "bg-gray-50" : "",
                                                  listed ? "" : "hidden",
                                                  "flex px-3 py-2 items-center text-sm leading-6 text-gray-900",
                                                )}
                                              >
                                                {
                                                  <MinusCircleIcon className="h-5 w-5 mt-1 mr-1" />
                                                }{" "}
                                                UnListApartment
                                                <span className="sr-only">
                                                  {" "}
                                                </span>
                                              </a>
                                              <a
                                                onClick={() =>
                                                  handleListApartment(
                                                    apartment.id,
                                                  )
                                                }
                                                href="#"
                                                className={classNames(
                                                  active ? "bg-gray-50" : "",
                                                  listed ? "hidden" : "",
                                                  "flex px-3 py-2 items-center text-sm leading-6 text-gray-900",
                                                )}
                                              >
                                                {
                                                  <CheckCircleIcon className="h-5 w-5 mt-1 mr-1" />
                                                }{" "}
                                                List Apartment
                                                <span className="sr-only">
                                                  {" "}
                                                </span>
                                              </a>
                                            </>
                                          )}
                                        </Menu.Item>

                                        <Menu.Item>
                                          {({ active }) => (
                                            <a
                                              onClick={() =>
                                                handleAddAppointment(apartment)
                                              }
                                              href="#"
                                              className={classNames(
                                                active ? "bg-gray-50" : "",
                                                "flex px-3 py-2 items-center text-sm leading-6 text-gray-900",
                                              )}
                                            >
                                              <PlusIcon className="h-5 w-5 mt-1 mr-1" />{" "}
                                              Add Appointment
                                              <span className="sr-only"> </span>
                                            </a>
                                          )}
                                        </Menu.Item>

                                        <Menu.Item>
                                          {({ active }) => (
                                            <a
                                              onClick={() =>
                                                handleShowAvailableAppointments(
                                                  apartment,
                                                )
                                              }
                                              href="#"
                                              className={classNames(
                                                active ? "bg-gray-50" : "",
                                                "flex px-3 py-2 items-center text-sm leading-6 text-gray-900",
                                              )}
                                            >
                                              <CalendarDaysIcon className="h-5 w-5  mr-1" />{" "}
                                              Show Available Appointments
                                              <span className="sr-only"> </span>
                                            </a>
                                          )}
                                        </Menu.Item>
                                        <Menu.Item>
                                          {({ active }) => (
                                            <a
                                              onClick={() =>
                                                handleAutomaticEmail(apartment)
                                              }
                                              href="#"
                                              className={classNames(
                                                active ? "bg-gray-50" : "",
                                                "flex px-3 py-2 items-center text-sm leading-6 text-gray-900",
                                              )}
                                            >
                                              {/* <CalendarDaysIcon className="h-5 w-5  mr-1" />{" "} */}
                                              {apartment.automaticEmail ? (
                                                <PauseCircle className="h-5 w-5  mr-1" />
                                              ) : (
                                                <PlayCircle className="h-5 w-5  mr-1" />
                                              )}

                                              {apartment.automaticEmail
                                                ? "Stop Automatic Email"
                                                : "Start Automatic Email"}

                                              <span className="sr-only"> </span>
                                            </a>
                                          )}
                                        </Menu.Item>

                                        <Menu.Item>
                                          {({ active }) => (
                                            <a
                                              href={`/emails/${apartment.id}`}
                                              className={classNames(
                                                active ? "bg-gray-50" : "",
                                                "flex px-3 py-2 items-center text-sm leading-6 text-gray-900",
                                              )}
                                            >
                                              <EmailIcon className="h-4 w-4 mr-1" />
                                              Emails
                                              <span className="sr-only"> </span>
                                            </a>
                                          )}
                                        </Menu.Item>
                                        <Menu.Item>
                                          {({ active }) => (
                                            <a
                                              href={`/inbox/${apartment.id}/${encodeURIComponent(apartment.title || "")}`}
                                              className={classNames(
                                                active ? "bg-gray-50" : "",
                                                "flex px-3 py-2 items-center text-sm leading-6 text-gray-900 relative",
                                              )}
                                            >
                                              <EmailIcon className="h-4 w-4 mr-2" />
                                              Inbox
                                              {/* 🔔 Notification Badge */}
                                              {emailCounts[apartment.id] >
                                                0 && (
                                                <span className="ml-auto bg-red-600 text-white text-xs rounded-full px-2 py-0.5">
                                                  {emailCounts[apartment.id]}
                                                </span>
                                              )}
                                            </a>
                                          )}
                                        </Menu.Item>

                                        <Menu.Item>
                                          {({ active }) => (
                                            <a
                                              href={`/kpis/${apartment.id}`}
                                              className={classNames(
                                                active ? "bg-gray-50" : "",
                                                "flex px-3 py-2 items-center text-sm leading-6 text-gray-900",
                                              )}
                                            >
                                              <ChartBarIcon className="h-5 w-5 mr-1" />
                                              KPIs
                                              <span className="sr-only"> </span>
                                            </a>
                                          )}
                                        </Menu.Item>
                                      </Menu.Items>
                                    </Transition>
                                  </Menu>
                                </td>
                              </tr>
                            ))}

                          {loading && (
                            <>
                              {filteredListings.length === 0 && (
                                <tr className="invisible h-12"></tr>
                              )}
                              <tr className="absolute bg-gray-300/80 top-0 left-0 p-4 w-full min-h-12 h-full flex items-center justify-center">
                                <Loading />
                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {filteredListings.length === 0 && !loading && (
                      <div className="hidden sm:flex text-gray-400 text-sm w-full border rounded-b-md shadow items-center justify-center p-2">
                        No Apartments
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Options Modal */}
            {mobileOptionsOpen && selectedApartmentForOptions && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 sm:hidden">
                <div className="bg-white rounded-lg w-[90%] max-w-sm mx-4 shadow-xl">
                  <div className="flex items-center justify-between px-4 py-3 border-b">
                    <h2 className="text-base font-semibold text-gray-900">
                      Options
                    </h2>
                    <button
                      onClick={handleCloseMobileOptions}
                      className="text-gray-400 hover:text-gray-600"
                    >
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                  <div className="py-2">
                    <button
                      onClick={() => {
                        handleAddEditListing(selectedApartmentForOptions);
                        handleCloseMobileOptions();
                      }}
                      className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-900 hover:bg-gray-50"
                    >
                      <PencilIcon className="h-5 w-5 text-gray-600" />
                      Edit Appartment
                    </button>
                    <button
                      onClick={() => {
                        navigate(
                          `/timeline/by-listing/${selectedApartmentForOptions.id}`,
                        );
                        handleCloseMobileOptions();
                      }}
                      className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-900 hover:bg-gray-50"
                    >
                      <ClockIcon className="h-5 w-5 text-gray-600" />
                      View Timeline
                    </button>
                    {listed ? (
                      <button
                        onClick={() => {
                          handleDeleteApartment(selectedApartmentForOptions);
                          handleCloseMobileOptions();
                        }}
                        className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-900 hover:bg-gray-50"
                      >
                        <MinusCircleIcon className="h-5 w-5 text-gray-600" />
                        UnListApartment
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          handleListApartment(selectedApartmentForOptions.id);
                          handleCloseMobileOptions();
                        }}
                        className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-900 hover:bg-gray-50"
                      >
                        <CheckCircleIcon className="h-5 w-5 text-gray-600" />
                        List Apartment
                      </button>
                    )}
                    <button
                      onClick={() => {
                        handleAddAppointment(selectedApartmentForOptions);
                        handleCloseMobileOptions();
                      }}
                      className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-900 hover:bg-gray-50"
                    >
                      <PlusIcon className="h-5 w-5 text-gray-600" />
                      Add Appointment
                    </button>
                    <button
                      onClick={() => {
                        handleShowAvailableAppointments(
                          selectedApartmentForOptions,
                        );
                        handleCloseMobileOptions();
                      }}
                      className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-900 hover:bg-gray-50"
                    >
                      <CalendarDaysIcon className="h-5 w-5 text-gray-600" />
                      Show Available Appointments
                    </button>
                    <button
                      onClick={() => {
                        handleAutomaticEmail(selectedApartmentForOptions);
                        handleCloseMobileOptions();
                      }}
                      className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-900 hover:bg-gray-50"
                    >
                      {selectedApartmentForOptions.automaticEmail ? (
                        <PauseCircle className="h-5 w-5 text-gray-600" />
                      ) : (
                        <PlayCircle className="h-5 w-5 text-gray-600" />
                      )}
                      {selectedApartmentForOptions.automaticEmail
                        ? "Stop Automatic Email"
                        : "Start Automatic Email"}
                    </button>
                    <a
                      href={`/emails/${selectedApartmentForOptions.id}`}
                      className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-900 hover:bg-gray-50"
                    >
                      <EmailIcon className="h-5 w-5 text-gray-600" />
                      Emails
                    </a>
                    <a
                      href={`/inbox/${selectedApartmentForOptions.id}/${encodeURIComponent(
                        selectedApartmentForOptions.title || "",
                      )}`}
                      className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-900 hover:bg-gray-50"
                    >
                      <EmailIcon className="h-5 w-5 text-gray-600" />
                      Inbox
                      {emailCounts[selectedApartmentForOptions.id] > 0 && (
                        <span className="ml-auto bg-red-600 text-white text-xs rounded-full px-2 py-0.5">
                          {emailCounts[selectedApartmentForOptions.id]}
                        </span>
                      )}
                    </a>
                    <a
                      href={`/kpis/${selectedApartmentForOptions.id}`}
                      className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-900 hover:bg-gray-50"
                    >
                      <ChartBarIcon className="h-5 w-5 text-gray-600" />
                      KPIs
                    </a>
                  </div>
                  <div className="px-4 py-3 border-t">
                    <button
                      onClick={handleCloseMobileOptions}
                      className="w-full py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}

            <AddAppointment
              open={openAddAppointment}
              setOpen={setOpenAddAppointment}
              isVacant={
                selectedListingsToAddAppointment?.isVacant !== undefined
                  ? selectedListingsToAddAppointment.isVacant
                  : false
              }
              listingId={selectedListingsToAddAppointment?.id ?? ""}
              appointmentToBeEdited={emptyAppointment}
            />
            <DefineSlotOrder
              open={showDefineSlotOrder}
              setOpen={setShowDefineSlotOrder}
              availableAppointments={emptyAppointments}
            />
            <AddListing
              open={showAddListing}
              setOpen={setShowAddListing}
              editListings={selectedListings}
              setEditListings={setSelectedListings}
              refreshApartments={refreshApartments}
              onModalClose={handleModalClose}
            />
            <MessageBox
              title={"Apartments - " + (listed ? "UnList" : "List")}
              message={
                "Are you sure you want to " +
                (listed ? "UnList" : "List") +
                " the selected apartment(s) along with their associated information?"
              }
              isOpen={openMessageBox}
              setIsOpen={setOpenMessageBox}
              okButtonText="Ok"
              cancelButtonText="Cancel"
              okButtonFunction={okButtonFunction}
              cancelButtonFunction={cancelButtonFunction}
              okButtonStyle={{
                backgroundColor: "rgb(79, 70, 229)",
              }}
              iconColor={{ color: "rgb(79, 70, 229)" }}
            />
            <MessageBox
              title={"Apartments " + (listed ? "UnList" : "List")}
              message={
                "This apartment has some available appointments. Are you sure you want to " +
                (listed ? "UnList" : "List") +
                " this?"
              }
              isOpen={openMessageBox2}
              setIsOpen={setOpenMessageBox2}
              okButtonText="Ok"
              cancelButtonText="Cancel"
              okButtonFunction={okButtonFunction2}
              cancelButtonFunction={() => setOpenMessageBox2(false)}
              okButtonStyle={{ backgroundColor: "#ff2c2c" }}
              iconColor={{ color: "#ff2c2c" }}
            />
          </div>
        )}
      </div>
    </>
  );
}
